import React, { Component } from 'react';

import AppStore from 'AppStore';
import { withRouter } from 'react-router-dom';

import * as Strings from 'app/utils/strings';
import CustomText from 'app/common/components/CustomText';
import CustomButton from 'app/common/components/CustomButton';
import CustomTextArea from 'app/common/components/CustomTextArea';
import CustomSelect from 'app/common/components/CustomSelect';
import CustomInput from 'app/common/components/CustomInput';
import TermOption from 'app/pages/quotes/components/TermOption';
import { shareQuote } from '../../QuoteActions';

import './SendQuotePage.css';

class SendQuotePage extends Component {
    constructor(props) {
        super(props);
        this.form = {};
    }

    componentWillMount = () => {
        AppStore.on('quote_shared', this.onQuoteShared);
        this.profile = AppStore.getProfile();
        if (!this.profile) {
            this.props.history.push('/profile' + this.props.match.url);
        }
    };

    componentWillUnmount = () => {
        AppStore.removeListener('quote_shared', this.onQuoteShared);
    };
    onQuoteShared = () => {
        alert(
            'Your quote has been sent and a copy has been sent to you. Thank you for using Canlease'
        );
        this.props.history.push('/');
    };
    isFormValid() {
        let isValid = true;
        Object.keys(this.form).forEach(key => {
            // if(this.form[key].hasOwnProperty("isValid"))
            if (
                typeof this.form[key].isValid === 'function' &&
                !this.form[key].isValid()
            ) {
                isValid = false;
            }
        });
        return isValid;
    }
    serializeForm = () => {
        const share = {};
        Object.keys(this.form).forEach(key => {
            // if(this.form[key].hasOwnProperty("isValid"))
            share[key] = this.form[key].state.value;
        });
        return share;
    };
    registerFormElement(key, element) {
        this.form[key] = element;
    }

    onBack = () => {};
    onSendToCustomer = () => {
        if (this.isFormValid()) {
            const share = this.serializeForm();
            share.terms = [24, 36, 48, 60];
            share.sender = this.profile;
            console.log(share);
            const quoteId = this.props.match.params.quoteId;
            shareQuote(quoteId, share);
        }
    };
    render() {
        return (
            <div className="hack">
                <div id="app-container">
                    <div>
                        <div id="quotes-container" className="form-container">
                            <h1>{Strings.QUOTES_SEND_QUOTE_TITLE}</h1>
                            <div className="row">
                                <CustomInput
                                    ref={CustomInput =>
                                        this.registerFormElement(
                                            'asset',
                                            CustomInput
                                        )
                                    }
                                    label="Equipment"
                                    placeholder={
                                        Strings.QUOTES_EQUIPMENT_PLACEHOLDER
                                    }
                                    required
                                />
                                <CustomInput
                                    ref={CustomInput =>
                                        this.registerFormElement(
                                            'businessName',
                                            CustomInput
                                        )
                                    }
                                    label="Business Name"
                                    placeholder={
                                        Strings.QUOTES_BUSINESS_NAME_PLACEHOLDER
                                    }
                                    required
                                />
                            </div>
                            <div className="row">
                                <CustomInput
                                    ref={CustomInput =>
                                        this.registerFormElement(
                                            'contactFirstName',
                                            CustomInput
                                        )
                                    }
                                    label="Contact First Name"
                                    placeholder={'John'}
                                    required
                                />
                                <CustomInput
                                    ref={CustomInput =>
                                        this.registerFormElement(
                                            'contactLastName',
                                            CustomInput
                                        )
                                    }
                                    label="Contact Last Name"
                                    placeholder={'Doe'}
                                    required
                                />
                            </div>
                            <div className="row">
                                <CustomInput
                                    ref={CustomInput =>
                                        this.registerFormElement(
                                            'contactEmail',
                                            CustomInput
                                        )
                                    }
                                    label="Contact Email"
                                    placeholder="bob@example.com"
                                    type="email"
                                    required
                                />
                            </div>
                            {/* <div className="row">
                                <CustomTextArea
                                    ref={CustomTextArea =>
                                        this.registerFormElement(
                                            'TextAreaMessage',
                                            CustomTextArea
                                        )
                                    }
                                    label="Email Message"
                                    value={Strings.QUOTES_EMAIL_MESSAGE_DEFAULT}
                                    required
                                />
                            </div> */}
                        </div>

                        {/* <CustomButton
                            action={this.onBack}
                            className="left back-button"
                        >
                            {Strings.QUOTES_BTN_BACK}
                        </CustomButton> */}
                        <CustomButton
                            className="right next-button"
                            action={this.onSendToCustomer}
                        >
                            {'Send Quote'}
                        </CustomButton>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(SendQuotePage);



// WEBPACK FOOTER //
// ./src/modules/quote/pages/send-quote/SendQuotePage.jsx